export default "__VITE_ASSET___2mgY0cQ__"